import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaFileAlt, FaDownload } from "react-icons/fa";
import { Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";

export default function Documents() {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userId = localStorage.getItem("userId");
  const BASE_URL = "https://backend.ems.hiradentallab.com"; // Backend Base URL

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        if (!userId) throw new Error("User ID not found in local storage");
        const response = await axios.get(`${BASE_URL}/api/user-files/${userId}`);
        setFiles(response.data.files);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchFiles();
  }, [userId]);

  const handleDownload = async (file) => {
    try {
      const response = await axios.get(`${BASE_URL}${file.path}`, {
        responseType: "blob", // Ensure it's received as a binary file
      });

      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", file.filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download file. Please try again.");
    }
  };

  if (loading)
    return (
      <div className="text-center text-xl font-semibold mt-10">
        Loading files...
      </div>
    );
  if (error)
    return <div className="text-center text-red-500 mt-10">Error: {error}</div>;

  return (
    <>
      <h1
        style={{ marginLeft: "20px", marginTop: "80px", fontSize: "2rem", color: "#0353a4" }}
      >
        Documents
      </h1>
      <hr />
      <div className="p-6 max-w-7xl mx-auto" style={{ padding: "40px" }}>
        <div className="d-flex flex-wrap justify-content-start gap-4 sm:flex-column">
          {files.length > 0 ? (
            files.map((file, index) => (
              <motion.div key={index} whileHover={{ scale: 1.05 }}>
                <Card
                  className="shadow-lg"
                  style={{ width: "18rem", borderRadius: "16px", border: "2px solid #0353a4" }}
                >
                  <Card.Body className="d-flex flex-column justify-content-center text-center">
                    <div className="w-full h-32 d-flex align-items-center justify-content-center bg-light rounded-lg mb-3">
                      {file.filename.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                        <img
                          src={`${BASE_URL}${file.path}`}
                          alt={file.filename}
                          style={{ width: "50px", height: "auto" }}
                        />
                      ) : (
                        <FaFileAlt className="text-gray-500 text-4xl" />
                      )}
                    </div>
                    <Card.Title style={{ color: "#0353a4", fontSize: "1rem" }}>
                      {file.filename}
                    </Card.Title>
                    <Button
                      variant="primary"
                      className="mt-2 d-flex align-items-center justify-content-center"
                      onClick={() => handleDownload(file)}
                    >
                      <FaDownload className="mr-1" /> Download
                    </Button>
                  </Card.Body>
                </Card>
              </motion.div>
            ))
          ) : (
            <div className="w-100 text-center text-gray-500">No files found</div>
          )}
        </div>
      </div>
    </>
  );
}